import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const xMontiWebsite =
  "6kqJaku3GHyXWuzAguwbEgw88KXf9Xjnhqwdq987dwqldkmdq9wd80dqwdlwqkdmqwd98w7dqwd";

const query = "query getQuizResults {klaviyoList {id list list_id}}";

export const fetchKlaviyoList = createAsyncThunk(
  "newsletter/fetchKlaviyoList",
  async () => {
    let data = JSON.stringify({
      query,
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://montessori-graphql-server-27e6d567583f.herokuapp.com/graphql",
      headers: {
        "Content-Type": "application/json",
        "x-monti-website": xMontiWebsite,
      },
      data,
    };
    let response = await axios
      .request(config)
      .then((response) => {
        if (response.data) {
          return response.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // console.log("# --response--> ", response);
    return response;
  },
);

const initialState = {
  value: [],
  klaviyoList: [],
  klaviyoEventData: [], //For testing
};

export const newsletterSlice = createSlice({
  name: "newsletter",
  initialState,
  reducers: {
    setNewsletterValue: (state, { payload }) => {
      state.value = payload;
    },
    setKlaviyoEventData: (state, { payload }) => {
      state.klaviyoEventData = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchKlaviyoList.fulfilled, (state, action) => {
      state.klaviyoList = action.payload;
      state.status = "succeeded";
    });
  },
});

export const selectNewsletterValue = (state) => state.newsletter.value;
export const selectKlaviyoList = (state) => state.newsletter.klaviyoList;
export const selectKlaviyoEventData = (state) =>
  state.newsletter.klaviyoEventData;

export const { setNewsletterValue, setKlaviyoEventData } =
  newsletterSlice.actions;
export default newsletterSlice.reducer;
